import { IDeck } from "./Deck";
import { ICardReference, ICard, CardType, CardSubType } from "./Card";
import { CardUtil } from "./CardUtil";

export class DeckUtil {
    static cardExists(deck: IDeck, card: ICardReference): boolean {
        if (!(deck && deck.cards && deck.cards.length)) {
            return false;
        }
        if (!card) return true;
        const filter = deck.cards.filter(c => CardUtil.equals(c, card));

        if (filter && filter.length) return true;
        return false;
    }
    static removeTopCard(deck: IDeck): ICard {
        if (deck && deck.cards && deck.cards.length) {
            const card = deck.cards[0];
            deck.cards.splice(0, 1);
            return card;
        }
        return null;
    }
    static addToTop(deck: IDeck, card: ICard) {
        deck.cards.splice(0, 0, card);
    }
    static addCards(deck: IDeck, cards: ICard[]) {
        deck.cards = deck.cards.concat(cards);
    }
    static add(deck: IDeck, card: ICard) {
        deck.cards.push(card);
    }
    static remove(deck: IDeck, index: number): ICard {
        const card = deck.cards[index];
        deck.cards.splice(index, 1);
        return card;
    }

    static removeTopCards(deck: IDeck, no: number, excludeType?: CardType[], excludeSubType?: CardSubType[]): ICard[] {
        const discards: ICard[] = [];
        const cards: ICard[] = [];
        while (cards.length < no && deck.cards.length > 0) {
            const card = this.removeTopCard(deck);
            if (excludeType && excludeType.some((ct) => ct === card.type)) {
                discards.push(card);
                continue;
            }
            if (excludeSubType && excludeSubType.some((st => st === card.subType))) {
                discards.push(card);
                continue;
            }
            cards.push(card);
        }
        if (discards.length) {
            this.addCards(deck, discards);
        }
        CardUtil.shuffle(deck.cards);
        return cards;
    }

    static hasCard(deck: IDeck): boolean {
        return !!(deck && deck.cards && deck.cards.length);
    }
    static list(deck: IDeck): ICard[] {
        if (!deck || !deck.cards || !deck.cards.length) return [];
        return deck.cards;
    }
    static listAllCardsOfType(deck: IDeck, cardType: CardType.Enemy): ICard[] {
        return this.list(deck).filter(c => c.type === cardType);
    }
    static readyExhaustedCards(deck: IDeck) {
        if (!deck || !deck.cards || !deck.cards.length) return;
        deck.cards.forEach(c => { c.exhausted = false; });
    }
}